import React from "react";
import EmojiCategoryItem from "./EmojiCategoryItem";

import "./style.scss";

const EmojiCategoriesList = ({categories, filteredEmoji, activeCategory, onSelectCategory}) => {
    return (
        <ul className="emoji-picker-category-list">
            {categories.map((category) => (
                (!!filteredEmoji?.[category].length || !filteredEmoji) &&
                <EmojiCategoryItem
                    key={category}
                    category={category}
                    activeCategory={activeCategory}
                    onClick={onSelectCategory}
                />
            ))}
        </ul>
    );
};

export default EmojiCategoriesList;
